import { Component } from '@angular/core';
import { NavParams, NavController, Platform, AlertController } from 'ionic-angular';
import { UserService } from "../../providers/session-service/user-service";
import { SchedulePage } from "../schedule/schedule";
import { ScoreboardPage } from "../scoreboard/scoreboard";
import { CallNumber } from '@ionic-native/call-number';
import { AngularFirestore } from 'angularfire2/firestore';
import { AngularFireDatabase } from 'angularfire2/database';

@Component({
    selector: 'page-team',
    templateUrl: 'team.html',
})
export class TeamPage {

    teammates: any;
    staff: any;
    team: any;
    showSpinner: boolean;
    sessionType: string;

    constructor(public platform: Platform, public navCtrl: NavController, public navParams: NavParams,
        private userService: UserService, private alertCtrl: AlertController, public db: AngularFirestore,
        private callNumber: CallNumber) {
        this.team = this.navParams.get('team');

        this.platform = platform;

        this.staff = [];
        this.teammates = [];
        this.showSpinner = false;
        this.sessionType = this.userService.getSessionType();
    }

    ionViewDidLoad() {
        this.teammates = this.team.roster;
        this.staff = this.team.staff;

        this.teammates.sort((a, b) => {
            return a.name >= b.name ? 1 : -1;
        });

        this.staff.sort((a, b) => {
            return a.name >= b.name ? 1 : -1;
        });
    }

    openSchedule() {
        this.navCtrl.push(SchedulePage, {
            'schedule': this.team.schedule,
        });
    }

    openScoreboard() {
        this.navCtrl.push(ScoreboardPage, {
            'scoreboard': this.team.scoreboard,
        });
    }

    callTeammate(person: any) {
        let index = person.phone.indexOf('-');
        let phone1 = person.phone;
        let phones = [];

        if (index !== -1) {
            let phone1 = person.phone.substring(0, index);
            let phone2 = person.phone.substring(index + 1);

            phones.push({
                type: 'radio',
                label: phone1.indexOf('(Γ)') !== -1 ? phone1.substring(0, index) + " (Τηλέφωνο γονέα)" : phone1,
                value: phone1.substring(0, index)
            });

            phones.push({
                type: 'radio',
                label: phone2.indexOf('(Γ)') !== -1 ? phone2.substring(0, index) + " (Τηλέφωνο γονέα)" : phone2,
                value: phone2.substring(0, index)
            });

            let alert = this.alertCtrl.create({
                title: 'Πραγματοποίηση κλήσης',
                message: 'Παρακαλώ επιλέξτε το τηλέφωνου το οποίο θέλετε να καλέσετε.',
                inputs: phones,
                buttons: [
                    {
                        text: 'Ακυρο',
                        role: 'cancel'
                    },
                    {
                        text: 'Κληση',
                        handler: phone => {
                            this.callNumber.callNumber(phone, true)
                        }
                    }
                ]
            });
            alert.present();
        } else {
            this.callNumber.callNumber(phone1, true)
        }

    }
}



// WEBPACK FOOTER //
// ./src/pages/team/team.ts